export enum EnvironmentType {
  Development = 'Development',
  Testing = 'Testing',
  UAT = 'UAT',
  PreProduction = 'Pre-production',
  Production = 'Production',
  Other = 'Other',
}
